(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-audio-player"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('article-audio-player-native')) {
    customElements.define(
      'article-audio-player-native',
      class ArticleAudioPlayer extends HTMLElement {
        connectedCallback() {
          if (this.isInitialized) return;

          this.isInitialized = true;
          this.audio = this.querySelector('[data-audio]');
          this.handlePlaybackState = () => this.updatePlaybackState();

          this.audio.addEventListener('play', this.handlePlaybackState);
          this.audio.addEventListener('pause', this.handlePlaybackState);
          this.audio.addEventListener('ended', this.handlePlaybackState);
          this.updatePlaybackState();
        }

        disconnectedCallback() {
          this.audio.removeEventListener('play', this.handlePlaybackState);
          this.audio.removeEventListener('pause', this.handlePlaybackState);
          this.audio.removeEventListener('ended', this.handlePlaybackState);
          this.isInitialized = false;
        }

        updatePlaybackState() {
          this.classList.toggle('is-playing', !this.audio.paused && !this.audio.ended);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solstar-concept-foundation"] && !Shopify.designMode) return;
  try {
    /* Intersection Observer for Concept Section & Fade-in Animations */
  document.addEventListener("DOMContentLoaded", function() {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 }); // 15%表示されたら発火に調整

    document.querySelectorAll('.se-card').forEach(card => observer.observe(card));
    document.querySelectorAll('.js-fade-in').forEach(el => observer.observe(el));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solstar-contact-scroll"] && !Shopify.designMode) return;
  try {
    (() => {
    const getForm = () => document.querySelector('.index-contact');

    const getHeaderOffset = () => {
      let offset = 0;
      const headers = document.querySelectorAll('header, [class*="header"], [class*="Header"]');

      headers.forEach((header) => {
        const styles = window.getComputedStyle(header);
        const isPinned = styles.position === 'fixed' || styles.position === 'sticky';

        if (isPinned && header.offsetHeight && header.getBoundingClientRect().top <= 1) {
          offset = Math.max(offset, header.offsetHeight);
        }
      });

      return offset;
    };

    const isContactTrigger = (trigger) => {
      if (!trigger) return false;
      const href = trigger.getAttribute('href') || '';
      return href.startsWith('#shopify-section-contact') || trigger.dataset.scrollToContact === 'true';
    };

    const updateContactLinks = () => {
      const form = getForm();
      const section = form?.closest('[id^="shopify-section-"]');

      if (!section) return;

      document
        .querySelectorAll('a.btn[href="#shopify-section-contact"], a.btn[data-scroll-to-contact="true"]')
        .forEach((link) => {
          if (!form.contains(link)) link.href = `#${section.id}`;
        });
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('a.btn');
      if (!isContactTrigger(trigger)) return;

      const form = getForm();
      if (!form || form.contains(trigger)) return;

      event.preventDefault();
      const top = form.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 12;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateContactLinks);
    } else {
      updateContactLinks();
    }

    document.addEventListener('shopify:section:load', updateContactLinks);
  })();
  } catch(e) { console.error(e); }
})();

})();
